import { type ComponentPropsWithoutRef, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type FileStatusPanelItemProps = Pick<ComponentPropsWithoutRef<'div'>, 'className' | 'onClick'> & {
  title: ReactNode;
  subtitle?: ReactNode;
  avatar: ReactNode;
  buttons: ReactNode;
  previewLoader?: ReactNode;
};

export const FileStatusPanelItem = memo(
  ({ className, title, subtitle, avatar, buttons, previewLoader, onClick }: FileStatusPanelItemProps) => (
    // biome-ignore lint/a11y/noStaticElementInteractions: <https://linear.app/air/issue/ENG-146/update-filestatuspaneitem-to-be-pass-a11y>
    // biome-ignore lint/a11y/useKeyWithClickEvents: <https://linear.app/air/issue/ENG-146/update-filestatuspaneitem-to-be-pass-a11y>
    <div className={cn('flex justify-between', className)} onClick={onClick}>
      {previewLoader}
      <div className="flex shrink">
        {avatar}

        <div className="flex flex-1 flex-col justify-center">
          {title}
          {subtitle}
        </div>
      </div>

      <div className="pane-item-buttons flex shrink-0 items-center justify-end gap-2.5 pl-2.5">{buttons}</div>
    </div>
  ),
);

FileStatusPanelItem.displayName = 'FileStatusPanelItem';
